export default __webpack_public_path__ + "static/media/tag4Icon.6bd3b15b.svg";